import { Injectable } from '@angular/core';
import { CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class ChildGuard implements CanActivateChild {

  canActivateChild(): Observable<boolean> | boolean {
    return true;
  }
}
